import React, { useState } from "react";
import "./Login.css";
import { useAuth } from "../auth/AuthProvider";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import AuthService from "../services/AuthService";
import PasswordInput from "../components/PasswordInput";

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);
  const [unverified, setUnverified] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pending) return;
    setPending(true);
    setUnverified(false);
    try {
      await login(email.trim(), password);
      navigate("/projects", { replace: true });
    } catch (err) {
      const msg = err?.message || "Sign-in failed. Please try again.";
      if (/verif/i.test(msg)) setUnverified(true);
      toast.error(msg);
    } finally {
      setPending(false);
    }
  };

  const resendVerification = async () => {
    try {
      await AuthService.resendVerification(email.trim());
      toast.success("Verification email sent. Check your inbox.");
    } catch {
      toast.info("If the account exists and is unverified, a link was sent.");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg" />
      <div className="auth-shell">
        <div className="auth-brand">
          <div className="auth-logo">
            <span className="auth-logoDot" />
          </div>
          <div className="auth-brandText">
            <div className="auth-appName">DIBS42</div>
            <div className="auth-appHint">Sign in to continue</div>
          </div>
        </div>

        <div className="auth-card">
          <h2 className="auth-title">Welcome to BIM Check</h2>
          <p className="auth-text">Sign in with your email and password.</p>

          <form onSubmit={submit}>
            <input
              className="auth-input"
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
            <PasswordInput
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button type="submit" className="auth-btn auth-btnPrimary" disabled={pending}>
              {pending ? "Signing in…" : "Sign in"}
            </button>
          </form>

          {unverified && (
            <button type="button" className="auth-resend" onClick={resendVerification}>
              Resend verification email
            </button>
          )}

          <div className="auth-links">
            <Link to="/forgot-password">Forgot password?</Link>
            <Link to="/register">Create account</Link>
          </div>

          <p className="auth-footnote">By signing in you agree to the terms of use.</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
